export default __webpack_public_path__ + "static/media/Marco Laureanti.b97a45a2.jpg";